/* KARMA valtok (nyelv, penznem): kattintas kivul es Escape zarja a legordulot. */
(function () {
  function zarMind(kiveve) {
    document.querySelectorAll('details[data-karma-valto][open]').forEach(function (d) {
      if (d !== kiveve) d.removeAttribute('open');
    });
  }
  document.addEventListener('click', function (e) {
    var nyitott = e.target.closest('details[data-karma-valto]');
    zarMind(nyitott);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') zarMind(null);
  });
})();

/* NYELVTARTO BELSO LINKEK (Balint 2026-10-15): angol nezetben a tartalomba es a temaba irt belso linkek
   (pl. "/pages/tortenetunk", "/collections/noi-kesztyu", termekleirasok, oldal-szovegek) a magyar oldalra
   vittek. A Shopify a beirt "/..." linket nem egesziti ki a nyelvi elotaggal. Itt minden belso,
   elotag nelkuli linket a jelenlegi nyelv gyokerere (pl. /en/) igazitunk. Kivetel: a nyelvvalto szandekos
   linkjei ([data-nyelv-marad], #karmaLocaleValt), rendszer-utvonalak (cdn, checkout, fiok, apps). */
(function () {
  var gyoker = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (gyoker === '/' || gyoker.length < 3) return;          /* alapnyelv: nincs teendo */
  var elotag = gyoker.replace(/\/$/, '');                    /* pl. "/en" */
  var KIHAGY = /^\/(cdn|checkouts?|cart\/|account|customer_authentication|apps|services|wpm|tools|s\/|localization|discount)/;
  function igazit(gyok) {
    (gyok || document).querySelectorAll('a[href^="/"]').forEach(function (a) {
      var h = a.getAttribute('href');
      if (!h || h.indexOf('//') === 0 || h === elotag || h.indexOf(elotag + '/') === 0) return;
      if (a.id === 'karmaLocaleValt' || a.hasAttribute('data-nyelv-marad') || KIHAGY.test(h)) return;
      a.setAttribute('href', elotag + (h === '/' ? '' : h));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { igazit(); });
  else igazit();
  /* kesobb betoltott reszek (kosarfiok, kereso-javaslat, Dawn-ujrarajzolas) */
  if (window.MutationObserver) new MutationObserver(function (lista) {
    lista.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) igazit(n.parentNode || n); }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
